import React from 'react';

import {
  Box,
  Grid,
  Stack,
  Button,
  Divider,
  useTheme,
  Typography,
  useMediaQuery,
} from '@mui/material';

import { useCustomNavigate } from 'src/hooks/use-custom-navigate';

import Logo from 'src/components/logo';
import Iconify from 'src/components/iconify';

import { navigationFooterInfo } from '../minimalFooter/minimalFooter';

export default function VerticalFooter() {
  const theme = useTheme();
  const isDownLg = useMediaQuery(theme.breakpoints.down('lg'));
  const isDownSm = useMediaQuery(theme.breakpoints.down('sm'));
  const isDown375 = useMediaQuery('(max-width: 375px)');
  const isDown320 = useMediaQuery('(max-width: 320px)');
  const navigate = useCustomNavigate();

  const handleRedirect = () => {
    window.open('https://cidade-center-norte.web.app/SE9NRV9TQ1JFRU5TL2luaWNpbw==');
  };

  const calcPx = () => {
    if (isDown320) {
      return 1;
    }
    if (isDownLg) {
      return 3;
    }
    return 12;
  };

  return (
    <>
      <Box bgcolor="#EAEEF5" px={calcPx()} pt={3}>
        <Stack direction="column" overflow="hidden">
          <Stack
            direction="column"
            spacing={3}
            justifyContent="space-between"
            alignContent="center"
          >
            <Stack direction="column" spacing={2} alignItems="center" justifyContent="center">
              <Box
                justifyContent="center"
                alignItems="center"
                sx={{
                  width: '162px',
                  height: '27px',
                }}
              >
                <Box
                  component="img"
                  src="/logo/footer_logo.png"
                  alt="Ilustração"
                  sx={{
                    width: '100%',
                    height: '100%',
                    objectFit: 'cover',
                    display: 'block',
                  }}
                />
              </Box>
              <Typography sx={{ fontSize: '18px' }} color="primary.main" fontWeight={700}>
                Suas visitas na Cidade Center Norte geram benefícios.
              </Typography>
              <Box
                justifyContent="center"
                alignItems="center"
                sx={{
                  maxWidth: '371px',
                  width: 'clamp(200px, 80vw, 371px)',
                  aspectRatio: '371 / 145',
                  overflow: 'hidden',
                }}
              >
                <Box
                  component="img"
                  src="/logo/footer_img.png"
                  alt="Ilustração"
                  sx={{
                    width: '100%',
                    height: '100%',
                    objectFit: 'contain',
                    display: 'block',
                  }}
                />
              </Box>
              <Stack direction="row" spacing={0.5} alignItems="center">
                <Iconify icon="ep:download" color="#D22E2D" width={24} height={24} />
                <Typography color="#D22E2D" variant="body1" fontWeight={700} lineHeight="140%">
                  Baixe o app Center Norte, faça parte <br />
                  do nosso clube e aproveite.
                </Typography>
              </Stack>
              <Button
                onClick={handleRedirect}
                sx={{
                  bgcolor: 'transparent',
                  py: 2,
                  px: 8,
                  width: 'clamp(150px, 100%, 327px)',
                  color: '#214983',
                  border: '1px solid var(--400-blue, #214983)',
                }}
              >
                Baixe o App
              </Button>
              <Box
                justifyContent="center"
                alignItems="center"
                sx={{
                  maxWidth: '300px',
                  aspectRatio: '300 / 50',
                  width: 'clamp(200px, 20vw, 300px)',
                  mt: -1,
                }}
              >
                <Box
                  component="img"
                  src="/logo/appstore_google_play.png"
                  alt="Ilustração"
                  sx={{
                    width: '100%',
                    height: '100%',
                    objectFit: 'contain',
                    display: 'block',
                  }}
                />
              </Box>
            </Stack>
          </Stack>
          <Divider color="#21498333" sx={{ opacity: '20%', mt: 7, width: '100vw' }} />
          <Box
            sx={{
              width: '100%',
              display: 'flex',
              justifyContent: 'center',
              maxHeight: '100px',
              alignItems: 'flex-end',
              pt: 12,
              aspectRatio: '538/65',
              minHeight: isDown320 ? '16px' : '32px',
            }}
          >
            <Logo
              data-testid="logo"
              customLogo="/logo/logo_cidade_center_norte.png"
              sx={{
                height: isDown320 ? 24 : 32,
                width: 'auto',
                maxWidth: '538px',
              }}
            />
          </Box>
          <Box
            sx={{
              mt: isDownSm ? 6 : 10,
              px: isDownSm ? 2 : 8,
              bgcolor: '#EAEEF5',
            }}
          >
            <Grid
              container
              spacing={isDownSm ? 1 : 2}
              justifyContent={isDownSm ? 'center' : 'space-evenly'}
              alignItems="center"
              mb={3}
              rowGap={isDownSm ? 3 : 2}
              columnGap={isDownSm ? 0 : 4}
            >
              {[
                { logo: 'shopping_center_norte.png', sx: { minWidth: '140px', height: '16px' } },
                { logo: 'lar_center.png', sx: { minWidth: '102px', height: '16px' } },
                { logo: 'expo_center_norte.png', sx: { minWidth: '140px', height: '16px' } },
                { logo: 'center_norte_inc.png', sx: { minWidth: '128px', height: '16px' } },
                { logo: 'instituto_center_norte.png', sx: { minWidth: '160px', height: '16px' } },
                { logo: 'novotel.png', sx: { minWidth: '116px', height: '16px' } },
              ].map((item, index) => (
                <Grid
                  item
                  xs={isDown375 ? 12 : 6}
                  sm={4}
                  md={2}
                  key={index}
                  display="flex"
                  justifyContent="center"
                >
                  <Box
                    component="img"
                    src={`/logo/${item.logo}`}
                    alt={`logo-${index}`}
                    sx={{
                      ...item.sx,
                      objectFit: 'contain',
                      display: 'block',
                    }}
                  />
                </Grid>
              ))}
            </Grid>
          </Box>
        </Stack>
      </Box>
      <Grid
        container
        sx={{
          bgcolor: '#214983',
          alignContent: 'center',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        {navigationFooterInfo.map((e, idx) => (
          <Grid item py={3} key={idx}>
            <Button
              sx={{ color: 'common.white', fontWeight: 500, fontSize: '16px', px: 3 }}
              onClick={() => {
                if (e?.type === 'open') {
                  window.open(e?.url);
                } else {
                  navigate(e?.url);
                }
              }}
              startIcon={e?.text === 'Fale conosco' ? <Iconify icon="ic:baseline-whatsapp" /> : undefined}
            >
              {e?.text}
            </Button>
          </Grid>
        ))}
      </Grid>
    </>
  );
}
